module.exports = __webpack_public_path__ + "static/img/bg-2.e9574250.png";